<div class="card" (click)="onClick.emit(streamId)">
    <!-- <div class="uppercase-label">{{ title }}</div> -->
    <div class="row w100 gap-8 align-center">
        <rr-icon [name]="icon" class="roundicon"></rr-icon>
        <h4 class="name">{{ buttonText }}</h4>
    </div>
</div>
